import React, { useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';

function Modal({ isOpen, onClose, children, style }) {
   const ref = useRef(null);

   useEffect(() => {
      if (isOpen) {
         ref.current?.showModal();
         document.body.classList.add('modal-open'); // prevent bg scroll
      } else {
         ref.current?.close();
         document.body.classList.remove('modal-open');
      }
   }, [isOpen]);

   const preventAutoClose = e => e.stopPropagation();

   return (
      <ModalWrap ref={ref} onCancel={onClose} onClick={onClose} style={style}>
         <ModalInnerWrap onClick={preventAutoClose}>{children}</ModalInnerWrap>
      </ModalWrap>
   );
}

export default Modal;

export const FadeInAnim = keyframes`
from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
`;

const ModalWrap = styled.dialog`
   border-radius: 8px;
   border: none;
   top: 50%;
   left: 50%;
   right: auto;
   bottom: auto;
   transform: translate(-50%, -50%);

   animation: ${FadeInAnim} 0.4s;

   &::backdrop {
      background: hsl(0 0% 10% / 0.5);
      backdrop-filter: blur(2px);
   }
`;

const ModalInnerWrap = styled.div``;
